/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Report API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponsePredefinedReportHistoryContentResponse,
  ApiResponsePredefinedReportHistoryFilterResponse,
  ApiResponsePredefinedReportHistoryListResponse,
  GetV1PreDefinedReportsHistoryContentParams,
  GetV1PreDefinedReportsHistoryListParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 사전 정의 리포트 발행 이력 > 다운로드용 Base64 조회
 */
export const getV1PreDefinedReportsHistoryContent = (
  params?: MaybeRef<GetV1PreDefinedReportsHistoryContentParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponsePredefinedReportHistoryContentResponse>(
    {
      url: `/api/v1/pre-defined/reports/history/content`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV1PreDefinedReportsHistoryContentQueryKey = (
  params?: MaybeRef<GetV1PreDefinedReportsHistoryContentParams>,
) => {
  return [
    'api',
    'v1',
    'pre-defined',
    'reports',
    'history',
    'content',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV1PreDefinedReportsHistoryContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryContent>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV1PreDefinedReportsHistoryContentParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV1PreDefinedReportsHistoryContentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryContent>>
  > = ({ signal }) => getV1PreDefinedReportsHistoryContent(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryContent>>,
    TError,
    TData
  >;
};

export type GetV1PreDefinedReportsHistoryContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryContent>>
>;
export type GetV1PreDefinedReportsHistoryContentQueryError = ErrorType<unknown>;

/**
 * @summary 사전 정의 리포트 발행 이력 > 다운로드용 Base64 조회
 */

export function useGetV1PreDefinedReportsHistoryContent<
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryContent>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV1PreDefinedReportsHistoryContentParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryContent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1PreDefinedReportsHistoryContentQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 사전 정의 리포트 발행 이력 > 목록 필터 조회
 */
export const getV1PreDefinedReportsHistoryFilters = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponsePredefinedReportHistoryFilterResponse>(
    { url: `/api/v1/pre-defined/reports/history/filters`, method: 'GET', signal },
    options,
  );
};

export const getGetV1PreDefinedReportsHistoryFiltersQueryKey = () => {
  return ['api', 'v1', 'pre-defined', 'reports', 'history', 'filters'] as const;
};

export const getGetV1PreDefinedReportsHistoryFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryFilters>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV1PreDefinedReportsHistoryFiltersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryFilters>>
  > = ({ signal }) => getV1PreDefinedReportsHistoryFilters(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryFilters>>,
    TError,
    TData
  >;
};

export type GetV1PreDefinedReportsHistoryFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryFilters>>
>;
export type GetV1PreDefinedReportsHistoryFiltersQueryError = ErrorType<unknown>;

/**
 * @summary 사전 정의 리포트 발행 이력 > 목록 필터 조회
 */

export function useGetV1PreDefinedReportsHistoryFilters<
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryFilters>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryFilters>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1PreDefinedReportsHistoryFiltersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 사전 정의 리포트 발행 이력 > 목록 조회
 */
export const getV1PreDefinedReportsHistoryList = (
  params: MaybeRef<GetV1PreDefinedReportsHistoryListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponsePredefinedReportHistoryListResponse>(
    {
      url: `/api/v1/pre-defined/reports/history/list`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV1PreDefinedReportsHistoryListQueryKey = (
  params?: MaybeRef<GetV1PreDefinedReportsHistoryListParams>,
) => {
  return [
    'api',
    'v1',
    'pre-defined',
    'reports',
    'history',
    'list',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV1PreDefinedReportsHistoryListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV1PreDefinedReportsHistoryListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV1PreDefinedReportsHistoryListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryList>>> = ({
    signal,
  }) => getV1PreDefinedReportsHistoryList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryList>>,
    TError,
    TData
  >;
};

export type GetV1PreDefinedReportsHistoryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryList>>
>;
export type GetV1PreDefinedReportsHistoryListQueryError = ErrorType<unknown>;

/**
 * @summary 사전 정의 리포트 발행 이력 > 목록 조회
 */

export function useGetV1PreDefinedReportsHistoryList<
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV1PreDefinedReportsHistoryListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1PreDefinedReportsHistoryList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1PreDefinedReportsHistoryListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
